import { useEffect } from "react";

/** Matches `public/index.html` default. */
export const DEFAULT_DOCUMENT_TITLE = "Graphen Inc.";

/** Set `document.title` while mounted; reset to site default on unmount. */
export function useDocumentTitle(title: string | undefined) {
    useEffect(() => {
        if (!title) return;

        document.title = title;

        return () => {
            document.title = DEFAULT_DOCUMENT_TITLE;
        };
    }, [title]);
}
